'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroParagraph = require('./NitroParagraph');

var _NitroParagraph2 = _interopRequireDefault(_NitroParagraph);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroParagraph2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-paragraph/index.js
// module id = 24
// module chunks = 4